import * as React from 'react';
// import { useEffect } from 'react';
import { BrowserRouter, Route, Router, Switch } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import { ILangInterface, LangProvider } from 'locales/provider';
import locale, { langAll } from 'locales';
import { LangConsumer } from 'locales/provider';
import Layout from 'styles/layout/default';
import Home from 'pages/index';
import Test from 'pages/test';

const baseUrl = process.env.PUBLIC_URL;
const history = createBrowserHistory({ basename: baseUrl });

interface Iprops {
  path: string;
  component: any;
  exact?: boolean;
  lang?: string;
  name?: string;
  messages?: any;
};

const routes = [
  {
    path: "/",
    component: Home,
    exact: true,
  },
  {
    path: "/home",
    component: Home,
    exact: true,
  },
  {
    path: "/home/:name",
    component: Home,
    exact: true,
  },
  {
    path: "/test",
    component: Test,
    exact: true,
  },
];

const routesAll = langAll.reduce((acc: any, obj: any, index: number, arr: any) => {
  routes.forEach(item => {
    !index && acc.push(item)

    item = {
      ...item,
      path: '/' + obj + (item.path === '/' ? '' : item.path),
    }

    acc.push(item);
  })
  return acc;
}, []);

const BindRoute:React.SFC<Iprops> = ({ component: Component, path, exact, ...rest }) => (
  <Route exact={exact} path={path} {...rest} render={props => (
    <Component {...rest} {...props} />
  )}/>
);

const Routes = (props?: any) => (
  <Layout>
    <Switch>
      {
        routesAll.map((route: any, index: any) => (
          <BindRoute 
            path={route.path}
            component={route.component}
            exact={route.exact}
            key={index}
            {...props} 
          />
        ))
      }
    </Switch>
  </Layout>
);

const Consumer = () => (
  <LangConsumer>
    {
      ctxApi => ctxApi && (
        <Routes key={1} lang={ctxApi.lang} name={ctxApi.name} messages={ctxApi.messages} reload={ctxApi.key} />
      )
    }
  </LangConsumer>
);


const AppRecive = (props:any) => {
  const { location, key } = props.history;
  const lang = localStorage.getItem('lang') || 'ko-KR';
  const nameTemp = location.pathname.replace(`/${lang}`, '').split('/');
  const name = nameTemp[1] || 'home';

  const localeSet: ILangInterface = {
    lang,
    name,
    messages: locale[lang][name],
    key: key || null
  }

  if (localeSet.messages) { document.title = localeSet.messages.title };

  if (location.pathname !== `${baseUrl}/${lang}/${name === 'home' && !nameTemp[2] ? '' : name}${nameTemp[2] ? `/${nameTemp[2]}` : ''}`) {
    history.location = {
      ...history.location,
      pathname: `/${lang}/${name === 'home' && !nameTemp[2] ? '' : name}${nameTemp[2] ? `/${nameTemp[2]}` : ''}`
    }

    window.history.replaceState({}, '', `${baseUrl}/${lang}/${name === 'home' && !nameTemp[2] ? '' : name}${nameTemp[2] ? `/${nameTemp[2]}` : ''}`);
  }

  return (
    <LangProvider value={localeSet}>
      <Consumer />
    </LangProvider>
  )
};

const App = () => (
  <BrowserRouter>
    <Router history={history}>
      <AppRecive history={history} />
    </Router>
  </BrowserRouter>
);



export default App;


// WEBPACK FOOTER //
// ./src/route.tsx